module.exports = __webpack_public_path__ + "static/media/propertymanagement.18e5afa8.webp";